import Icon from "@material-ui/icons/PictureAsPdf";
import CustomerReceiptsCreate from "./CustomerReceiptsCreate";
import CustomerReceiptsList from "./CustomerReceiptsList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "customerReceipts",
  create: CustomerReceiptsCreate,
  list: CustomerReceiptsList,
  icon: Icon,
};
